module.exports = __webpack_public_path__ + "img/huace12.d0bf413d.jpg";